import { useTranslation } from 'next-i18next'

import WishlistShareSection from '../wishlist-share-section'
import { WishlistShareSectionProps } from '../wishlist-share-section/wishlist-share-section'

import styles from './wishlist-heading.module.scss'

type PropType = {
  name?: string
  isSelfWishlist?: boolean
} & Pick<WishlistShareSectionProps, 'wishListProductList'>

function WishlistHeading({ name, isSelfWishlist, wishListProductList }: PropType) {
  const { t } = useTranslation('wishlist')
  return (
    <div className={styles.headingWrapper}>
      <h1 className={styles.heading}>{name ? t('favorites_possessive', { name: name }) : t('my_favorites')}</h1>
      {name ? <div className={styles.subHeading}>{t('heres_whats_on_their_wishlist')}</div> : null}
      {isSelfWishlist ? <WishlistShareSection wishListProductList={wishListProductList} /> : null}
    </div>
  )
}

export default WishlistHeading
